var map = {
	"./Gallery/Gallery-1.jpg": 37,
	"./Gallery/Gallery-10.jpg": 38,
	"./Gallery/Gallery-11.jpg": 39,
	"./Gallery/Gallery-12.jpg": 40,
	"./Gallery/Gallery-13.jpg": 41,
	"./Gallery/Gallery-15.jpg": 42,
	"./Gallery/Gallery-16.jpg": 43,
	"./Gallery/Gallery-17.jpg": 44,
	"./Gallery/Gallery-18.jpg": 45,
	"./Gallery/Gallery-19.jpg": 46,
	"./Gallery/Gallery-2.jpg": 47,
	"./Gallery/Gallery-20.jpg": 48,
	"./Gallery/Gallery-21.jpg": 49,
	"./Gallery/Gallery-22.jpg": 50,
	"./Gallery/Gallery-23.jpg": 51,
	"./Gallery/Gallery-3.jpg": 52,
	"./Gallery/Gallery-4.jpg": 53,
	"./Gallery/Gallery-5.jpg": 54,
	"./Gallery/Gallery-6.jpg": 55,
	"./Gallery/Gallery-7.jpg": 56,
	"./Gallery/Gallery-8.jpg": 57,
	"./Gallery/Gallery-9.jpg": 58,
	"./Gallery/Gallery-BG.jpg": 59,
	"./Landing-1.jpg": 60,
	"./Landing-2.jpg": 61,
	"./Landing-3.jpg": 62,
	"./Landing-BG-mobile.jpg": 114,
	"./Landing-BG-sm.jpg": 115,
	"./Landing-BG.jpg": 116,
	"./Logo-2-wh.png": 117,
	"./Logo-2.png": 118,
	"./Logo-sm.png": 30,
	"./Logo-str-2.png": 63,
	"./Logo-str.png": 64,
	"./Menu/Menu-1.jpg": 65,
	"./Menu/Menu-10.jpg": 66,
	"./Menu/Menu-11.jpg": 67,
	"./Menu/Menu-12.jpg": 68,
	"./Menu/Menu-13.jpg": 69,
	"./Menu/Menu-2.jpg": 70,
	"./Menu/Menu-3.jpg": 71,
	"./Menu/Menu-4.jpg": 72,
	"./Menu/Menu-5.jpg": 73,
	"./Menu/Menu-6.jpg": 74,
	"./Menu/Menu-7.jpg": 75,
	"./Menu/Menu-8.jpg": 76,
	"./Menu/Menu-9.jpg": 77,
	"./Menu/Menu-dimsum-BG.jpg": 78,
	"./Menu/Menu-dimsum-BG2.jpg": 79,
	"./Reservation/Reservation-BG.jpg": 119
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 113;